module.exports = __webpack_public_path__ + "img/governor.079394ab.png";